import { getServer } from "@translations/next";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import AboutSustainabilityContainer from "@containers/AboutSustainabilityContainer";
import WrapperProvider from "@providers/WrapperProvider";
import _ from "lodash";
import Layout from "@components/Layout";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";

export default function View(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <AboutSustainabilityContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}

// export { getServerSideProps };
export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "group-sustainability-page");
  const res = await StrapiService.find({ populate: "deep", locale });
  const footerData = await FooterService.fetchByHotel(undefined, locale);
  return {
    pageData: _.get(res, "data", {}),
    footerData,
  };
});
